import { render, staticRenderFns } from "./EducationPDFLessonsLesson.vue?vue&type=template&id=79ca2ce4&"
import script from "./EducationPDFLessonsLesson.vue?vue&type=script&lang=js&"
export * from "./EducationPDFLessonsLesson.vue?vue&type=script&lang=js&"
import style0 from "./EducationPDFLessonsLesson.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports